/* eslint-disable react-hooks/exhaustive-deps */

import { useAppDispatch } from "app/hooks";
import { useEffect } from "react";
import toast from "react-hot-toast";
import { getAccountDetails, getProfile } from "features/main/profile/slice";

const UseProfileModel = () => {
  const dispatch = useAppDispatch();

  const handleGetProfile = () => {
    const onFailure = (errorResponse: IErrorResponse) => {
      toast.error(errorResponse.message);
    };

    dispatch(getProfile({ onFailure }));
  };

  const handleGetAccountDetails = () => {
    const onFailure = (errorResponse: IErrorResponse) => {
      toast.error(errorResponse?.message ?? "Could not load your permissions.");
    };

    dispatch(getAccountDetails({ onFailure }));
  };

  useEffect(() => {
    handleGetProfile();
    handleGetAccountDetails();
  }, []);

  return {};
};

export default UseProfileModel;
